import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ReciclosService } from 'src/app/reciclos/reciclos.service';

import 'dayjs/locale/es' 
import * as relativeTime from 'dayjs/plugin/relativeTime';
import * as dayjs from 'dayjs';
import { RecicloIncentivable } from 'src/app/models/reciclo-incentivable.model';

@Component({
  selector: 'app-contenedor-incentivables-chart',
  templateUrl: './contenedor-incentivables-chart.component.html',
  styleUrls: ['./contenedor-incentivables-chart.component.scss']
})
export class ContenedorIncentivablesChartComponent implements OnInit {

  @Input() datamatrix: string;
  @Input() inicio: string;
  @Input() fin: string;

  chartType: string = 'bar';
  chartDatasets: Array<any> = [{data: []}];
  chartLabels: Array<any> = [];
  chartColors: Array<any> = [
    {
      backgroundColor: 'rgba(58, 90, 64, .75)',
      borderColor: 'rgba(58, 90, 64, .75)',
      borderWidth: 0,
    },
    {
      backgroundColor: 'rgba(88, 129, 87, .75)',
      borderColor: 'rgba(88, 129, 87, .75)',
      borderWidth: 0,
    },
  ];
  chartOptions: any = {
    elements: { rectangle: { borderWidth: 2} },
    responsive: true,
    legend: { position: 'bottom'},
    title: { display: true, text: 'Bonificables por día' },
    scales: {
      yAxes: [{
        ticks: { beginAtZero: true, precision: 0 },
        stacked: true,
      }],
      xAxes: [{
        stacked: true,
      }]
    }
  }

  constructor(
    private reciclosService: ReciclosService,
  ) {
    dayjs.locale('es');
    dayjs.extend(relativeTime);
  }

  ngOnInit(): void {
    this.loadData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['inicio']?.currentValue || changes['fin']?.currentValue)
      this.loadData();
  }

  loadData() {
    const options = { inicio: this.inicio, fin: this.fin};
    this.reciclosService.getReciclosIncentivablesByDatamatrix(this.datamatrix, options).subscribe(
      reciclos => this.createChart(reciclos)
    );
  }

  createChart(reciclos: Array<RecicloIncentivable>) {
    const incentivable = [];
    const noincentivable = [];
    const labels = [];
    const data = {};
    reciclos.forEach(reciclo => {
      data[`${reciclo.fecha}`] = { incentivable: reciclo.incentivables, noincentivable: reciclo.noincentivables};
    });
    let dia = dayjs(this.inicio);
    while (dia.toISOString() < this.fin) {
      const fecha = dia.format('YYYYMMDD');
      const hasProperty = data.hasOwnProperty(fecha);
      incentivable.push(hasProperty ? data[fecha].incentivable : 0);
      noincentivable.push(hasProperty ? data[fecha].noincentivable : 0);
      labels.push(dia.format('ddd DD'));
      dia = dia.add(1, 'day');
    }
    this.chartLabels = labels;
    this.chartDatasets = [
      {label: 'Bonificables', data: incentivable},
      {label: 'No Bonificables', data: noincentivable}
    ];
  }
}
